import React, { memo } from "react";
import { Loader2 } from "lucide-react";
export const Loader = memo(({ texts }) => {
    return (React.createElement("div", { className: "flex items-center justify-start gap-2" },
        React.createElement(Loader2, { className: "w-5 h-5 animate-spin text-gray-600" }),
        React.createElement("span", { className: "text-sm text-gray-600" }, texts[0])));
});
